import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Row, Col } from "reactstrap";


class Skoba extends Component {
  componentDidMount() {
    // задание backgroundColor (по цветовому коду) и color (по яркости backgroundColor) для найденных селекторов
    const items = document.querySelectorAll(".acce-page-color .item");
    items.forEach((item) => {
      item.style.cssText = `background:#${item.classList[1]}`;

      // (!) Цветовой код селектора интерпретируется браузером как 'rgb(int, int, int)'
      // массив с числовыми значениями rgb-оттенков: [r, g, b]
      let rgb = item.style.backgroundColor.match(/\d+/g);
      // коэффициент восприимчивости яркости цвета
      let k = 1 - (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
      // неяркий цвет - цвет шрифта белый, яркий цвет - цвет шрифта чёрный
      let fontColor = k < 0.5 ? "#000" : "#fff";
      item.style.cssText += `color:${fontColor}`;
    });
  }

  render() {
    return (
      <div className="thread-page">
        <Helmet>
          <link rel="canonical" href="https://vektor.club/goods/skoba" />
        </Helmet>

        <Row className="acce-page-top">
          <Col xs="12" className="aces-page-top-text">
            <div className="aces-page-top-title">
              <h1 className="h1">Скоба</h1>
            </div>
            <div className="aces-page-top-table">
              <table>
                <thead>
                  <tr>
                    <td>Наименование</td>
                    <td>Кол-во</td>
                    <td>Цена</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Скоба обивочная 80-06</td>
                    <td>1000 шт</td>
                    <td>18,10 ₽</td>
                  </tr>
                  <tr>
                    <td>Скоба обивочная 80-08</td>
                    <td>1000 шт</td>
                    <td>20,5 ₽</td>
                  </tr>
                  <tr>
                    <td>Скоба обивочная 80-10</td>
                    <td>1000 шт</td>
                    <td>23,5 ₽</td>
                  </tr>
                  <tr>
                    <td>Скоба обивочная 80-12</td>
                    <td>1000 шт</td>
                    <td>26,5 ₽</td>
                  </tr>
                  <tr>
                    <td>Скоба обивочная 80-14
                    </td>
                    <td>1000шт</td>
                    <td>29,6 ₽</td>
                  </tr>
                  <tr>
                    <td>Скоба обивочная 80-16
                    </td>
                    <td>1000 шт</td>
                    <td>32,8 ₽</td>
                  </tr>
                  <tr>
                    <td>Скоба каркасная 14-25
                    </td>
                    <td>1000 шт</td>
                    <td>142 ₽</td>
                  </tr>
                  <tr>
                    <td>Скоба каркасная 14-30
                    </td>
                    <td>1000 шт</td>
                    <td>165 ₽</td>
                  </tr>
                  <tr>
                    <td>Скоба каркасная 14-38
                    </td>
                    <td>1000 шт</td>
                    <td>199 ₽</td>
                  </tr>
                  <tr>
                    <td>Скоба каркасная 14-50
                    </td>
                    <td>1000 шт</td>
                    <td>255 ₽</td>
                  </tr>




                </tbody>
              </table>
            </div>
          </Col>
        </Row>

        <div className="acce-page-bottom"><div className="acce-page-color opora"></div></div>


      </div>
    );
  }
}

export default Skoba;
